export default __webpack_public_path__ + "static/cert-icon-03-245bcb58f427b9872991995e5377115e.png";